// extracted by mini-css-extract-plugin
export var content = "_qx-1";
export var fullScreen = "_qx-0";